export var getAuthStatus = function getAuthStatus(isAuthenticated, isAuthorized) {
  if (isAuthenticated && isAuthorized) {
    return 'Authenticated';
  }
  if (isAuthorized && !isAuthenticated) {
    return 'Remember';
  }
  return 'Not authenticated';
};